<template>
    <b-modal size="lg" :title="Core.Definition.getDefinition('PDF')" :hide-footer="true" v-model="dataShow">
        <iframe style="height:800px" width="100%" v-if="dataDocumentUrl !== ''" :src="dataDocumentUrl"></iframe>
    </b-modal>
</template>

<script>
    export default {
        name: 'ModalPDFView',
        components: {
        },
        props: {
        },
        computed: {
            open: {
                set(open) {
                    this.dataShow = open
                },
                get() {
                    return this.dataShow
                }
            },
            id: {
                set(val) {
                    this.dataId = val
                },
                get() {
                    return this.dataId
                }
            },
            documentUrl: {
                set(val) {
                    this.dataDocumentUrl = val
                },
                get() {
                    return this.dataDocumentUrl
                }
            }
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataShow: false,
                dataDocumentUrl: ''
            }
        },
        methods: {
        }
    }
</script>
